import httpClient from '@/http-client'

export const get = (options = {}) => {
	return httpClient
		.get('/api/event-invitations', options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}
export const store = data => {
	return httpClient
		.post('/api/event-invitations', data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}
export const find = (id, Options = {}) => {
	return httpClient
		.get(`/api/event-invitations/${id}`, Options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}
export const update = data => {
	return httpClient
		.put(`/api/event-invitations/${data.upload_id}`, data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}
export const destroy = id => {
	return httpClient
		.delete(`/api/event-invitations/${id}`)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}
export const invitationSubject = (options = {}) => {
	return httpClient
		.get('/api/event-invitations/invitation-subjects', options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}
export const previewPdf = (Options = {}) => {
	return httpClient
		.get('/api/event-invitations/preview-pdf', Options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const eventVenue = (options = {}) => {
	return httpClient
		.get('/api/event-invitations/event-venues', options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export default {
	get,
	store,
	find,
	update,
	destroy,
	invitationSubject,
	previewPdf,
	eventVenue
}
